import { useDispatch } from "react-redux";
import BilderButtons from "../../Common/Detalj/BilderButtons";

import {
    getMiljogebyr as getMiljogebyrAction,
    getMiljogebyrerHistorikk,
    postMiljogebyrerBilder as postMiljogebyrerBilderAction
} from "../../../actions/miljogebyrerActions";

export default function BilderButtonsContainer({ id }) {
  const dispatch = useDispatch();

  function handleLeggTilBilderClick(invisibleFileInputButton) {
    invisibleFileInputButton.click();
  }

  const handleFileInputChange = (fileArray) => {
    const uploads = [];
    for (let index = 0; index < fileArray.length; index++) {
      uploads.push(
        dispatch(postMiljogebyrerBilderAction(id, fileArray[index.toString()]))
      );
    }
    Promise.all(uploads)
      .then(() => {
        dispatch(getMiljogebyrAction(id));
        dispatch(getMiljogebyrerHistorikk(id));
      })
      .catch();
  };

  return (
    <BilderButtons
      handleFileInputChange={handleFileInputChange}
      handleLeggTilBilderClick={handleLeggTilBilderClick}
    />
  );
}
